import { useEffect, useState } from "react";
import { AiKey, aiDisplayName, detectMentionedAi, isAiLimitReached } from "../utils/aiTokenLimit";

/**
 * Detecta, enquanto o usuário digita, se ele mencionou @pacoca_ai ou @BochechaAI
 * e se essa IA já atingiu o limite diário de tokens (segundo o cache local).
 * Retorna o nome da IA para exibir o aviso, ou null caso não deva ser exibido.
 */
export function useAiMentionLimitBanner(text: string, idUser: number | undefined): string | null {
    const [aiName, setAiName] = useState<string | null>(null);

    useEffect(() => {
        const mentioned: AiKey | null = detectMentionedAi(text);

        if (mentioned && isAiLimitReached(mentioned, idUser)) {
            setAiName(aiDisplayName(mentioned));
        } else {
            setAiName(null);
        }
    }, [text]);

    return aiName;
}
